const skillGroups = [
  {
    category: "Frontend",
    items: ["React", "Next.js", "TypeScript", "HTML & CSS"],
  },
  {
    category: "Backend",
    items: ["C#", ".NET", "Node.js", "Express", "REST APIs"],
  },
  {
    category: "Data",
    items: ["PostgreSQL", "SQL Server", "Entity Framework"],
  },
  {
    category: "Delivery",
    items: ["Railway", "Docker", "Git", "GitHub"],
  },
];

export default function Skills() {
  return (
    <section className="section section--soft" id="capabilities">
      <div className="section-wrap">
        <div className="section-heading">
          <div>
            <p className="eyebrow">Tools of the trade</p>
            <h2>Comfortable across the stack.</h2>
          </div>
          <p className="section-heading__aside">
            A focused toolkit for building, connecting, and shipping web software.
          </p>
        </div>
        <div className="skills-grid">
          {skillGroups.map((group) => (
            <div className="skill-group" key={group.category}>
              <h3>{group.category}</h3>
              <div className="tag-list">
                {group.items.map((item) => <span key={item}>{item}</span>)}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
